module.exports = __webpack_public_path__ + "static/media/kamsiah.8332c154.png";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/LandingPage/img/kamsiah.png
// module id = 1607
// module chunks = 0